var _g, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGold(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "idEVcVKg1EEg-1532669426",
    x1: 0.49751243781094523,
    x2: 0.5024875621890548,
    y1: 0,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "rgb(255,231,170)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "rgb(170,128,0)",
    stopOpacity: 1
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M 23.814 10.042 C 22.661 9.127 22.068 7.703 22.237 6.246 C 22.347 5.288 22.017 4.347 21.339 3.669 C 20.661 2.992 19.72 2.661 18.763 2.771 C 17.297 2.941 15.881 2.347 14.966 1.195 C 14.364 0.441 13.475 0.008 12.508 0.008 C 11.542 0.008 10.644 0.441 10.051 1.195 C 9.136 2.347 7.712 2.941 6.254 2.771 C 5.297 2.661 4.356 2.992 3.678 3.669 C 3 4.347 2.669 5.288 2.78 6.246 C 2.949 7.712 2.356 9.127 1.203 10.042 C 0.449 10.644 0.017 11.534 0.017 12.5 C 0.017 13.466 0.449 14.356 1.203 14.958 C 2.356 15.873 2.949 17.297 2.78 18.754 C 2.669 19.712 3 20.653 3.678 21.331 C 4.356 22.008 5.297 22.339 6.254 22.229 C 7.72 22.059 9.136 22.653 10.051 23.805 C 10.653 24.559 11.542 24.992 12.508 24.992 C 13.475 24.992 14.364 24.559 14.966 23.805 C 15.881 22.653 17.305 22.059 18.763 22.229 C 19.72 22.339 20.661 22.008 21.339 21.331 C 22.017 20.653 22.347 19.712 22.237 18.754 C 22.068 17.288 22.661 15.873 23.814 14.958 C 24.568 14.356 25 13.466 25 12.5 C 25 11.534 24.568 10.636 23.814 10.042 Z",
    fill: "url(#idEVcVKg1EEg-1532669426)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 11.61 16.873 L 11.61 9.542 L 11.525 9.542 L 9.271 11.042 L 9.271 9.254 L 11.61 7.712 L 13.364 7.712 L 13.364 16.881 L 11.61 16.881 Z",
    fill: "rgb(255,255,255)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGold);
export default __webpack_public_path__ + "static/media/Gold.2cad62fb660adb9e912b05a5070ba52a.svg";
export { ForwardRef as ReactComponent };